// Carry Roll PersistErrorBanner — surfaces localStorage quota failures.

import { useStore } from '../../store';

export function PersistErrorBanner() {
  const persistError = useStore((s) => s.persistError);
  const clearPersistError = useStore((s) => s.clearPersistError);

  if (!persistError) return null;

  return (
    <div
      role="alert"
      data-testid="persist-error-banner"
      className="flex items-center justify-between gap-3 px-4 py-2 text-sm"
      style={{
        backgroundColor: 'color-mix(in srgb, var(--color-danger) 14%, transparent)',
        borderBottom: '1px solid var(--color-danger)',
      }}
    >
      <span>{persistError}</span>
      <button
        type="button"
        onClick={clearPersistError}
        className="shrink-0 text-xs underline"
        style={{
          color: 'var(--color-text-muted)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          transition: 'color var(--motion-fast)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--color-text)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--color-text-muted)';
        }}
      >
        Dismiss
      </button>
    </div>
  );
}
